
define('text!presentation/settings/userGroup/views/userGroupVoicemailSubscribers.html',[],function () { return '<div class="voicemail-subscribers"\n     data-bind="compose: { model: subscriberSelectionViewModel, activate: false }">\n</div>';});

